<template>
  <v-container fluid fill-height>
    <v-row justify="center" align="center">
      <v-col align="center" cols="12"><h1>Perfumist</h1></v-col>
      <v-col align="center" cols="12"
        ><h2 class="red--text">
          Error: Invalid or expired invitation
        </h2></v-col
      >
      <v-col align="center" cols="12"
        >Please contact the person who invited you</v-col
      >
      <v-col align="center" cols="12"
        >If you have an account you can join the login page by clicking on this
        button</v-col
      >
      <v-btn
        @click="$router.replace('/signin')"
        label="Connexion"
        color="primary"
        class="mt-4"
        >Login page</v-btn
      >
    </v-row>
  </v-container>
</template>

<script>
export default {}
</script>

<style scoped></style>
